module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', {
    attrs: {
      "header-bgc": true
    }
  }, [_c('template', {
    slot: "page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("关于我们")]), _c('p', [_vm._v("CDP 融合了市面上各家 CDN 厂商，致力于打造新一代的智能融合云服务平台，为企业提供更加快速、安全、稳定的域名调度解决方案，\n帮助企业统一调配管理各 CDN 厂商的服务，做到让企业更加省心、放心")]), _c('h2', [_vm._v("我们的优势")]), _c('p', [_vm._v("融合各热门 CDN 厂商")]), _c('p', [_vm._v("可按任意比例配置调度各 CDN 厂商间流量的平台")]), _c('p', [_vm._v("灵活调度，实现域名的所有访问地区都有本地节点覆盖")]), _c('p', [_vm._v("问题节点智能切换，保证域名正常运行")]), _c('p', [_vm._v("多维度告警通知，实时掌握网站动态")]), _c('h2', [_vm._v("联系我们")]), _c('p', [_vm._v("公司地址：杭州市西湖区文一西路522号9幢1单元602室")]), _c('p', [_vm._v("邮箱：sales@oncdp.com")])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55dc1061","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contact.vue
// module id = 48
// module chunks = 0